import { isPlatform } from "@ionic/vue";

export const createRedirectUri = (packageId, domain) => {
  const isNative = isPlatform("ios") || isPlatform("android");
  const isNativeBrowser = isPlatform("mobileweb");

  return isNative && !isNativeBrowser
    ? `${packageId}://${domain}/capacitor/${packageId}/callback`
    : (window.location.origin + '/callback');
};

export const createLogoutUri = (packageId, domain) => {
  const isNative = isPlatform("ios") || isPlatform("android");
  const isNativeBrowser = isPlatform("mobileweb");

  return isNative && !isNativeBrowser
    ? `${packageId}://${domain}/capacitor/${packageId}/logout`
    : (window.location.origin);
};

export const redirectNoAccess = (router) => {
  router.push("/");
};

export const redirectDeepLinkPath = (router, url) => {
  const urlObj = new URL(url);
  if (urlObj.origin === process.env.VUE_APP_APP_DOMAIN) {
    const params = new URLSearchParams(urlObj.search);
    const paramsObject = {};
    for (let [key, value] of params.entries()) {
      paramsObject[key] = value;
    }
    // this one for redirect after deep linking login
    const deepLinkPathObj = {
      path: urlObj.pathname,
      query: paramsObject,
      hash: urlObj.hash,
    };
    sessionStorage.setItem("deepLinkPathObj", JSON.stringify(deepLinkPathObj));
    router.push(deepLinkPathObj);
    return true;
  }
  return false;
};

export const storeLoginPath = (url) => {
  console.log("store login:", url);
  const urlObj = new URL(url);
  const params = new URLSearchParams(urlObj.search);
  const paramsObject = {};
  for (let [key, value] of params.entries()) {
    paramsObject[key] = value;
  }
  // this one for redirect after deep linking login
  const loginPathObj = {
    path: urlObj.pathname,
    query: paramsObject,
    hash: urlObj.hash,
  };
  sessionStorage.setItem("loginPathObj", JSON.stringify(loginPathObj));
};

export const getLoginPathObj = () => {
  const loginPathObjString = sessionStorage.getItem("loginPathObj");
  if (!loginPathObjString) return null;
  return JSON.parse(loginPathObjString);
};

export const clearLoginPathObj = () => {
  console.log("clearLoginPathObj")
  sessionStorage.removeItem("loginPathObj");
}